export default {
    comingSoon: "เร็ว ๆ นี้",
    backHome: "กลับหน้าแรก",
    pages: {
        about: "เกี่ยวกับเรา",
        signUp: "สร้างบัญชี",
        forgotPassword: "ลืมรหัสผ่าน",
        resetPassword: "ตั้งรหัสผ่านใหม่",
        resetPasswordSent: "ส่งลิงก์รีเซ็ตแล้ว",
        confirmEmail: "ยืนยันอีเมล",
        userSetup: "ตั้งค่าบัญชี",
        myCart: "ตะกร้าของฉัน",
        accountSettings: "ตั้งค่าบัญชี",
        productsList: "สินค้า",
        productDetails: "รายละเอียดสินค้า",
        shippingDetails: "รายละเอียดการจัดส่ง",
        shippingAddresses: "ที่อยู่จัดส่ง",
        shippingAddressNew: "ที่อยู่จัดส่งใหม่",
        shippingAddressEdit: "แก้ไขที่อยู่จัดส่ง",
        myOrders: "คำสั่งซื้อของฉัน",
        orderDetails: "รายละเอียดคำสั่งซื้อ",
        orderConfirmation: "ยืนยันคำสั่งซื้อ",
        payment: "การชำระเงิน",
        categories: "หมวดหมู่",
        notifications: "การแจ้งเตือน",
        notFound: "ไม่พบหน้านี้"
    }
} as const;
